<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"></a><a id="page_v"><span class="txit">For Chuchi and Zoom-Zoom and the memory of their father, Robert R. Churchill</span></a></p><a id="page_v">
<p class="imagec"><img alt="Images" height="33" src="images/f000v-01.jpg" width="35"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?64e8f647